function Appointment(axios, baseUrl) {
  this.axios = axios;
  this.baseUrl = `${baseUrl}appointment`;

  this.get = function(appointmentId, requesterId) {
    let self = this;
    return self.axios.get(`${self.baseUrl}/${appointmentId}/${requesterId}`);
  };
  this.getByDate = function(date) {
    let self = this;
    return self.axios.get(`${self.baseUrl}/getByDate/${date}`);
  };
  this.getByDateAndStudioListIndex = function(
    date,
    studioListIndex,
    requesterId
  ) {
    let self = this;
    return self.axios.get(
      `${
        self.baseUrl
      }/ByDateAndStudioIndex/${date}/${studioListIndex}/${false}/${requesterId}`
    );
  };
  this.getByDateAndStudioListIndexSingle = function(
    date,
    studioListIndex,
    requesterId
  ) {
    let self = this;
    return self.axios.get(
      `${
        self.baseUrl
      }/ByDateAndStudioIndex/${date}/${studioListIndex}/${true}/${requesterId}`
    );
  };
  this.getByUser = function(userId, pageNumber, getEnded) {
    let self = this;
    return self.axios.get(
      `${self.baseUrl}/getByUser/${userId}/${pageNumber}/${getEnded}`
    );
  };

  /* ADMIN APPOINTMENT LIST VIEW */

  this.getForAdmin = function(
    pageNumber,
    getOnlyEnded,
    showAppointmentsWithouthReport
  ) {
    let self = this;
    return self.axios.get(
      `${
        self.baseUrl
      }/getForAdmin/${pageNumber}/${getOnlyEnded}?unmarkedAppointments=${showAppointmentsWithouthReport}`
    );
  };

  this.adminListByDate = function(
    pageNumber,
    date,
    showAppointmentsWithouthReport
  ) {
    let self = this;
    return self.axios.get(
      `${
        self.baseUrl
      }/adminListByDate/${pageNumber}/${date}?unmarkedAppointments=${showAppointmentsWithouthReport}`
    );
  };

  this.adminListByStudio = function(
    pageNumber,
    studioId,
    showAppointmentsWithouthReport
  ) {
    let self = this;
    return self.axios.get(
      `${
        self.baseUrl
      }/adminListByStudio/${pageNumber}/${studioId}?unmarkedAppointments=${showAppointmentsWithouthReport}`
    );
  };

  this.adminListByAppointmentType = function(
    pageNumber,
    appointmetTypeId,
    showAppointmentsWithouthReport
  ) {
    let self = this;
    return self.axios.get(
      `${
        self.baseUrl
      }/adminListByAppointmentType/${pageNumber}/${appointmetTypeId}?unmarkedAppointments=${showAppointmentsWithouthReport}`
    );
  };

  /* END OF ADMIN APPOINTMENT LIST VIEW */
  this.add = function(model) {
    let self = this;
    return self.axios.post(`${self.baseUrl}`, model);
  };
  this.update = function(model) {
    let self = this;
    return self.axios.put(`${self.baseUrl}`, model);
  };
  this.remove = function(id, userId) {
    let self = this;
    return self.axios.delete(`${self.baseUrl}/${id}/${userId}`);
  };
  // Report for profile page
  this.getReportsForProfile = function(pageNumber, params) {
    let self = this;
    return self.axios.post(
      `${self.baseUrl}/listForProfile/${pageNumber}`,
      params
    );
  };
  // Delete multiple appointments
  this.deleteAppointments = function(model) {
    let self = this;
    return self.axios.post(`${self.baseUrl}/deleteAppointments/`, model);
  };
}

export default Appointment;
